// fbConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// const firebaseConfig = {
//   apiKey: "AIzaSyClkZDuOsRySGPCgC5sLx9oflisx4WfWHI",
//   authDomain: "deroyalecashflow.firebaseapp.com",
//   projectId: "deroyalecashflow",
//   storageBucket: "deroyalecashflow.firebasestorage.app",
//   messagingSenderId: "563692809805",
//   appId: "1:563692809805:web:37b3a76fd98e36bcacf604"
// };

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDFMMFxJ6yHOV0ZYe3sje8cTYjd_LkMlCo",
  authDomain: "deroyalehospify.firebaseapp.com",
  projectId: "deroyalehospify",
  storageBucket: "deroyalehospify.firebasestorage.app",
  messagingSenderId: "283474150484",
  appId: "1:283474150484:web:6a4d50a17b642aa58d59c1"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Get Firestore, Auth, and Storage instances
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);

auth.settings.appVerificationDisabledForTesting = true;

// ✅ Export everything you need
export { db, auth, storage, firebaseConfig };
